import React from "react";
import { CopyButton } from "../shared";

const PROMPTS = [
  "What's my wallet balance?",
  "Register my username as @myname",
  "Send 0.001 ETH to @akram on Base testnet",
  "How much gas to send ETH on Polygon?",
];

export default function TestPrompts() {
  return (
    <div className="mcp-test-prompts">
      <h5 className="mcp-subsection-title">Step 3: Test it</h5>
      <p className="mcp-step-desc">
        Try these example prompts with your AI agent:
      </p>
      <div className="mcp-prompt-list">
        {PROMPTS.map((prompt) => (
          <div key={prompt} className="mcp-prompt-item">
            <span className="mcp-prompt-text">"{prompt}"</span>
            <CopyButton text={prompt} label="Copy" className="mcp-btn-xs" />
          </div>
        ))}
      </div>
    </div>
  );
}
